export default "__VITE_ASSET__Cuyj95Ei__"